import React from 'react';
import Media from '../media';
import Typo from '../typo';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { IMG_BASE_PATH } from 'utils/constants';

// import 'swiper/swiper-bundle.min.css'; // Import Swiper styles

// Sample dynamic content
const pagination = {
  clickable: true,
  renderBullet: function (index, className) {
    return '<span class="' + className + '">' + (index + 1) + '</span>';
  }
};
const howToPlayData = [
  {
    imgSrc: 'htp1.svg',
    imgAlt: 'htp1',
    heading: 'pick_your_team',
    caption: 'pick_your_team_cap'
  },
  {
    imgSrc: 'htp2.svg',
    imgAlt: 'htp2',
    heading: 'late_subsmission',
    caption: 'late_subsmission_cap'
  },
  {
    imgSrc: 'htp3.svg',
    imgAlt: 'htp3',
    heading: 'player_usage',
    caption: 'player_usage_cap'
  },
  {
    imgSrc: 'htp4.svg',
    imgAlt: 'htp4',
    heading: 'score_win',
    caption: 'score_win_cap'
  }
  // Add more items as needed
];

const HowToPlay = () => {
  return (
    <div className='si-htp__swiper'>
      <Typo transKey={'htp_heading'} component='h4' className='si-htp__heading'>
        HOW TO PLAY
      </Typo>
      <div className='si-htp__swiper-inner'>
        <Swiper
          direction={'vertical'}
          // pagination={{
          //   clickable: true
          // }}
          pagination={pagination}
          modules={[Pagination]}
          className='mySwiper'
        >
          {howToPlayData.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <div className='si-htp__swiper-thumb'>
                  <Media
                    imgSrc={`${IMG_BASE_PATH}images/htp/${item.imgSrc}`}
                    imgAlt={item.imgAlt}
                    fallback={`${IMG_BASE_PATH}images/htp/htp1.svg`}
                  />
                </div>
                <div className='si-htp__swiper-content'>
                  <Typo
                    transKey={item.heading}
                    component='h5'
                    className='si-htp__swiper-title'
                  >
                    {/* {item.heading} */}
                  </Typo>
                  <Typo transKey={item.caption} component='p' className='si-htp__swiper-caption'>
                    {/* {item.caption} */}
                  </Typo>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};

export default HowToPlay;
